<template>
  <v-multiselect
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="$emit('input', $event)"

    :options="options"
    :searchable="true"
    :loading="isLoading"
    :internal-search="false"
    :track-by="trackBy"
    :placeholder="placeholder"
    @search-change="onSearch"
    @open="onOpen"
  >
    <template v-for="(content, name) in $slots" :slot="name">
      <slot :name="name"><vnode :node="content"/></slot>
    </template>

    <template v-for="(content, name) in $scopedSlots" :slot="name" slot-scope="props">
      <slot :name="name" v-bind="props">
        <vnode :node="content"/>
      </slot>
    </template>
  </v-multiselect>
</template>

<script>
  import debounce from 'lodash/debounce'
  import isEqual from 'lodash/isEqual'
  import api from '@/api'

  export default {
    props: {
      value: {},
      placeholder: {
        type: String,
        default: 'Поиск',
      },
      trackBy: {
        type: String,
        default: () => 'id',
      },
      debounceDelay: {
        type: Number,
        default: () => 300,
      },
      endpoint: {
        type: String,
        required: true,
      },
      endpointParams: {
        type: Object,
        default: () => {},
      },
      modifyOptions: {
        type: Function,
        default: (options) => options,
      },
      lazy: {
        type: Boolean,
        default: () => false,
      }
    },
    data () {
      return {
        isLoading: false,
        options: [],
        firstOpen: true,
      }
    },
    methods: {
      onSearch (term) {
        this.isLoading = true
        this.debouncedSearch(term)
      },
      search (term) {
        this.isLoading = true
        const params = Object.assign({}, this.endpointParams, {term})
        api
          .get(this.endpoint, {params})
          .then(({data}) => {
            this.options = this.modifyOptions(data.data)
            this.isLoading = false
          })
      },
      onOpen () {
        if (this.lazy && this.firstOpen) {
          this.firstOpen = false
          this.search('')
        }
      }
    },
    watch: {
      endpointParams (nv, ov) {
        if (!isEqual(nv, ov)) {
          this.search('')
        }
      }
    },
    computed: {
      debouncedSearch () {
        return debounce(this.search, this.debounceDelay)
      },
    },
    mounted () {
      if (!this.lazy) this.search('')
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/server-select.vue